import { OrderProductDiscount } from "ts/api/order";
import { useShowDiscountCodes } from "store/discount-code/discount-code-store";
import { useCurrentShowId } from "hooks";
import { IDiscountCode } from "@evennt-tech/api-v2-core";

export const useMergedProductDiscountCodes = (
  productDiscountCodes: OrderProductDiscount[] = []
) => {
  const showId = useCurrentShowId();
  const appliedDiscountCodes = useShowDiscountCodes(showId);

  if (!productDiscountCodes.length) {
    return [];
  }
  return productDiscountCodes.reduce<
    (IDiscountCode & { amount: number; error?: string })[]
  >((acc, curr) => {
    const discountCode = appliedDiscountCodes.find(
      (code) => code.id === curr.id
    );
    if (!discountCode) {
      return acc;
    }
    const fullDiscountAmount =
      curr.amountWithFees +
      curr.extras.reduce(
        (extrasDiscount, extra) => extrasDiscount + extra.amountWithFees,
        0
      );
    acc.push({
      ...discountCode,
      amount: fullDiscountAmount,
      ...(discountCode.error && { error: discountCode.error }),
    });

    return acc;
  }, []);
};
